/*
  Kraba: the storefront behaviour the Kraba sections need on top of Multi.

  Product page (variants, quantity, add to cart, gallery, sticky bar), the
  cart drawer and cart page, the slide-out menu, the header search, the quick
  add window and a few small things. Business rules (EasySell, bundles, tiers,
  delivery dates, search synonyms) stay in kraba-product.js, which talks to
  this markup through the same class names as before.

  Nothing here re-renders the product form. A variant change rewrites values
  in place, so buttons other scripts put next to ours (EasySell) stay put.
*/
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function $(selector, root) { return (root || document).querySelector(selector); }
  function $$(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function readJSON(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* window.fetch is looked up on every call, so kraba-product.js can wrap it
     (search synonyms) after this file has loaded */
  function request(url, options) { return window.fetch(url, options); }

  /* ======================================================================
     Quantity boxes, product page and cart alike
     ====================================================================== */
  function clampQuantity(input) {
    var min = parseInt(input.getAttribute('min'), 10);
    var max = parseInt(input.getAttribute('max'), 10);
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = isNaN(min) ? 1 : min;
    if (!isNaN(min) && value < min) value = min;
    if (!isNaN(max) && value > max) value = max;
    input.value = value;
    var box = input.closest('quantity-input');
    if (box) {
      var minus = $('[name="minus"]', box);
      var plus = $('[name="plus"]', box);
      if (minus) minus.classList.toggle('disabled', !isNaN(min) && value <= min);
      if (plus) plus.classList.toggle('disabled', !isNaN(max) && value >= max);
    }
    return value;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('quantity-input .quantity__button');
    if (!button) return;
    event.preventDefault();
    var input = $('.quantity__input', button.closest('quantity-input'));
    if (!input) return;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var before = parseInt(input.value, 10) || 0;
    input.value = before + (button.name === 'plus' ? step : -step);
    var after = clampQuantity(input);
    if (after !== before) input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('quantity-input .quantity__input');
    if (input) clampQuantity(input);
  }, true);

  /* ======================================================================
     Product page
     ====================================================================== */
  function initProduct(root) {
    if (!root || root.dataset.krabaThemeReady) return;
    root.dataset.krabaThemeReady = '1';

    var inModal = !!root.closest('quick-add-modal');
    var form = $('form[data-type="add-to-cart-form"]', root);
    var idInput = $('.product-variant-id', root);
    var selects = $('variant-selects', root);
    var variants = selects ? readJSON($('script[type="application/json"]', selects)) : null;
    var data = readJSON($('[data-kraba-variant-data]', root)) || {};
    var button = $('.product-form__submit', root);
    var sticky = $('[data-kraba-sticky]', root);
    var gallery = $('kraba-gallery', root);

    $$('quantity-input .quantity__input', root).forEach(clampQuantity);

    function currentOptions() {
      var values = [];
      $$('.product-form__input', selects).forEach(function (group) {
        var position = parseInt(group.dataset.optionPosition, 10) - 1;
        var picked = $('input[type="radio"]:checked', group) || $('select', group);
        if (picked) values[position] = picked.value;
      });
      return values;
    }

    function findVariant(values) {
      if (!variants) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var n = 0; n < values.length; n++) {
          if (values[n] != null && v.options[n] !== values[n]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* which values of each option can still be bought with the others as they are */
    function markAvailability(values) {
      if (!variants || values.length < 2) return;
      $$('.product-form__input', selects).forEach(function (group) {
        var position = parseInt(group.dataset.optionPosition, 10) - 1;
        $$('input[type="radio"]', group).forEach(function (radio) {
          var probe = values.slice();
          probe[position] = radio.value;
          var hit = findVariant(probe);
          radio.classList.toggle('disabled', !hit || !hit.available);
        });
      });
    }

    function updateLabels(values) {
      var format = selects && selects.dataset.labelFormat;
      if (!format) return;
      $$('[data-kraba-option-label]', selects).forEach(function (label) {
        var group = label.closest('.product-form__input');
        var position = parseInt(group.dataset.optionPosition, 10) - 1;
        var text = format.replace('[name]', label.dataset.name).replace('[selected]', values[position] || '');
        var holder = $('span', label) || label;
        holder.textContent = text;
      });
    }

    function setButton(available) {
      if (button) {
        button.disabled = !available;
        var text = $('[data-kraba-atc-text]', button);
        if (text) text.textContent = available ? (button.dataset.krabaLabel || text.textContent) : button.dataset.soldOutLabel;
      }
      if (sticky) {
        var sb = $('.sticky-atc__button', sticky);
        var label = $('[data-kraba-sticky-label]', sticky);
        if (sb) sb.disabled = !available;
        if (label) label.textContent = available ? (label.dataset.label || label.textContent) : (button ? button.dataset.soldOutLabel : label.textContent);
      }
    }

    function setPrice(info) {
      var box = $('[data-kraba-price]', root);
      if (box && info) {
        var now = $('[data-kraba-price-now]', box);
        var sale = $('[data-kraba-price-sale]', box);
        var was = $('[data-kraba-price-was]', box);
        var badge = $('[data-kraba-price-badge]', box);
        if (now) now.textContent = info.price;
        if (sale) sale.textContent = info.price;
        if (was) was.textContent = info.compare || '';
        box.classList.toggle('price--on-sale', !!info.compare);
        box.classList.toggle('price--sold-out', !info.available);
        if (badge) {
          badge.hidden = !info.compare;
          var nowrap = $('.nowrap', badge);
          if (nowrap && info.saving) nowrap.textContent = nowrap.textContent.replace(/\d+%/, info.saving + '%');
        }
      }
      if (sticky && info) {
        var sp = $('[data-kraba-sticky-price]', sticky);
        if (sp) sp.textContent = info.price;
        var img = $('[data-kraba-sticky-image]', sticky);
        if (img && info.image) { img.src = info.image; img.removeAttribute('srcset'); }
      }
    }

    function applyVariant(variant) {
      if (!variant) {
        setButton(false);
        return;
      }
      var info = data[variant.id] || { price: '', available: variant.available };

      if (idInput) {
        idInput.value = variant.id;
        idInput.setAttribute('value', variant.id);
        idInput.disabled = !variant.available;
      }
      setPrice(info);
      setButton(variant.available);

      var qty = $('.quantity__input', root);
      if (qty && info.max) { qty.setAttribute('max', info.max); clampQuantity(qty); }

      if (sticky) {
        var ss = $('[data-kraba-sticky-variant]', sticky);
        if (ss && ss.value !== String(variant.id)) ss.value = variant.id;
      }
      if (gallery && info.media && gallery.goToMedia) gallery.goToMedia(info.media);

      if (!inModal && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      root.dispatchEvent(new CustomEvent('kraba:variant-change', { bubbles: true, detail: { variant: variant } }));
    }

    function onOptionChange() {
      var values = currentOptions();
      updateLabels(values);
      markAvailability(values);
      applyVariant(findVariant(values));
    }

    if (selects) selects.addEventListener('change', onOptionChange);

    /* the sticky bar's own picker drives the page's picker, never the other way round */
    if (sticky) {
      var ss = $('[data-kraba-sticky-variant]', sticky);
      if (ss) ss.addEventListener('change', function () {
        var wanted = null;
        (variants || []).forEach(function (v) { if (String(v.id) === ss.value) wanted = v; });
        if (!wanted || !selects) return;
        wanted.options.forEach(function (value, index) {
          var group = $('.product-form__input[data-option-position="' + (index + 1) + '"]', selects);
          if (!group) return;
          var select = $('select', group);
          if (select) { select.value = value; return; }
          $$('input[type="radio"]', group).forEach(function (radio) { radio.checked = radio.value === value; });
        });
        onOptionChange();
      });
      initSticky(root, sticky);
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        addToCart(form, button, root.dataset.skipCart === 'true' && !inModal);
      });
    }

    if (gallery) initGallery(gallery);
  }

  function showFormError(form, message) {
    var wrap = form.closest('.product-form');
    var holder = wrap && $('.product-form__error-message-wrapper', wrap);
    if (!holder) return;
    if (!message) { holder.hidden = true; return; }
    $('.product-form__error-message', holder).textContent = message;
    holder.hidden = false;
  }

  function addToCart(form, button, skipCart) {
    var payload = new FormData(form);
    var qtyField = form.id ? document.querySelector('input[name="quantity"][form="' + form.id + '"]') : null;
    if (qtyField && !payload.get('quantity')) payload.set('quantity', qtyField.value);
    payload.append('sections', SECTIONS);
    payload.append('sections_url', window.location.pathname);

    if (button) button.classList.add('loading');
    showFormError(form, null);

    return request('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: payload })
      .then(function (response) { return response.json().then(function (json) { return { ok: response.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok || result.json.status) {
          showFormError(form, result.json.description || result.json.message || '');
          return;
        }
        if (skipCart) { window.location.href = '/checkout'; return; }
        renderCartSections(result.json.sections);
        var modal = form.closest('quick-add-modal');
        if (modal && modal.hide) modal.hide();
        openDrawer();
      })
      .catch(function () { form.submit(); })
      .then(function () { if (button) button.classList.remove('loading'); });
  }

  /* ---------------- sticky bar ---------------- */
  function initSticky(root, bar) {
    var anchor = $('.product-form__quantity-and-btn', root) || $('.product-form', root);
    if (bar.dataset.display === 'always' || !anchor || !('IntersectionObserver' in window)) {
      bar.hidden = false;
      bar.classList.add('is-visible');
      return;
    }
    bar.hidden = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    }).observe(anchor);
  }

  /* ---------------- gallery ---------------- */
  function initGallery(host) {
    if (host.dataset.ready) return;
    host.dataset.ready = '1';
    var track = $('[data-kraba-gal-track]', host);
    var slides = $$('.kraba-gal__slide', host);
    var dots = $$('.kraba-gal__dot', host);
    var thumbs = $$('.thumbnail', host);
    var list = $('[data-kraba-thumbs]', host);
    if (!track || !slides.length) return;
    var index = 0;

    function setActive(i) {
      index = i;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (list && thumbs[i]) {
        var item = thumbs[i].parentElement;
        var left = item.offsetLeft - (list.clientWidth - item.clientWidth) / 2;
        list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
      playActive();
    }

    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }

    host.goToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(mediaId)) { goTo(i); return; }
      }
    };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var width = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / width);
        if (i !== index && slides[i]) setActive(i);
      });
    }, { passive: true });

    var prev = $('[data-kraba-gal-prev]', host);
    var next = $('[data-kraba-gal-next]', host);
    if (prev) prev.addEventListener('click', function () { goTo(index - 1 < 0 ? slides.length - 1 : index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1 >= slides.length ? 0 : index + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.dataset.index, 10)); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10)); }); });

    var tp = $('[data-kraba-thumbs-prev]', host);
    var tn = $('[data-kraba-thumbs-next]', host);
    if (tp && list) tp.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.8, behavior: 'smooth' }); });
    if (tn && list) tn.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' }); });

    /* videos: only the one on screen plays */
    function playActive() {
      slides.forEach(function (slide, n) {
        var holder = $('internal-video', slide);
        if (!holder) return;
        var video = $('video', holder);
        if (!video) return;
        if (n !== index) { if (!video.paused) video.pause(); return; }
        if (holder.dataset.autoplay !== 'true') return;
        var source = $('source[data-src]', holder);
        if (source && !source.getAttribute('src')) {
          source.setAttribute('src', source.getAttribute('data-src'));
          video.load();
        }
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      });
    }

    $$('[data-kraba-gal-sound]', host).forEach(function (button) {
      button.addEventListener('click', function () {
        var video = $('video', button.closest('internal-video'));
        if (!video) return;
        video.muted = !video.muted;
        var icon = $('.material-icon', button);
        if (icon) icon.textContent = video.muted ? 'volume_off' : 'volume_up';
      });
    });

    $$('[data-kraba-external]', host).forEach(function (box) {
      box.addEventListener('click', function () {
        var parts = box.dataset.krabaExternal.split(':');
        var src = parts[0] === 'youtube'
          ? 'https://www.youtube.com/embed/' + parts[1] + '?autoplay=1&playsinline=1&rel=0'
          : 'https://player.vimeo.com/video/' + parts[1] + '?autoplay=1';
        box.innerHTML = '<iframe src="' + src + '" allow="autoplay; encrypted-media; fullscreen" allowfullscreen title="Video"></iframe>';
      }, { once: true });
    });

    /* arriving with ?variant= shows that variant's photo first */
    var start = 0;
    slides.forEach(function (s, n) { if (s.classList.contains('is-active')) start = n; });
    if (start) {
      window.requestAnimationFrame(function () { goTo(start, true); });
    } else {
      playActive();
    }
  }

  /* ======================================================================
     Cart: drawer, header count, cart page
     ====================================================================== */
  function drawer() { return $('kraba-cart-drawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d || window.location.pathname === '/cart') return;
    d.open();
  }

  if (!customElements.get('kraba-cart-drawer')) {
    customElements.define('kraba-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (event) {
          if (event.target.closest('[data-kraba-drawer-close]')) { event.preventDefault(); self.close(); }
        });
      }
      open() {
        this.syncEmpty();
        this.classList.add('active', 'animate');
        document.documentElement.classList.add('kraba-drawer-open');
        var inner = $('.drawer__inner', this);
        if (inner) setTimeout(function () { inner.focus({ preventScroll: true }); }, 50);
      }
      close() {
        this.classList.remove('active');
        document.documentElement.classList.remove('kraba-drawer-open');
      }
      syncEmpty() { this.classList.toggle('is-empty', !$('.cart-item', this)); }
    });
  }

  function renderCartSections(sections) {
    if (!sections) return;
    var d = drawer();
    if (sections['cart-drawer'] && d) {
      var fresh = $('kraba-cart-drawer', parse(sections['cart-drawer']));
      if (fresh) {
        d.innerHTML = fresh.innerHTML;
        d.syncEmpty();
      }
    }
    if (sections['cart-icon-bubble']) {
      var host = document.getElementById('cart-icon-bubble');
      if (host) {
        var freshBubble = $('.cart-count-bubble', parse(sections['cart-icon-bubble']));
        var liveBubble = $('.cart-count-bubble', host);
        if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
        else if (freshBubble) host.appendChild(freshBubble);
        else if (liveBubble) liveBubble.remove();
      }
    }
    /* cart page: only the inner contents, so EasySell's button in .cart__ctas stays */
    $$('[data-kraba-cart-items]').forEach(function (items) {
      var html = sections[items.dataset.id];
      if (!html) return;
      var doc = parse(html);
      if (!$('.cart-item', doc)) { window.location.reload(); return; }
      var a = $('#main-cart-items .js-contents', doc);
      var b = $('#main-cart-items .js-contents', items);
      if (a && b) b.innerHTML = a.innerHTML;
    });
    var footer = document.getElementById('main-cart-footer');
    if (footer && sections[footer.dataset.id]) {
      var fdoc = parse(sections[footer.dataset.id]);
      var fa = $('#main-cart-footer .js-contents', fdoc);
      var fb = $('.js-contents', footer);
      if (fa && fb) fb.innerHTML = fa.innerHTML;
      var st = $('[data-kraba-cart-sticky-total]', fdoc);
      var sl = $('[data-kraba-cart-sticky-total]', footer);
      if (st && sl) sl.textContent = st.textContent;
    }
  }

  function cartSectionIds() {
    var ids = SECTIONS.split(',');
    $$('[data-kraba-cart-items]').forEach(function (n) { ids.push(n.dataset.id); });
    var footer = document.getElementById('main-cart-footer');
    if (footer) ids.push(footer.dataset.id);
    return ids;
  }

  var changing = Promise.resolve();
  function changeLine(key, quantity, origin) {
    var line = origin && origin.closest('.cart-item');
    if (line) line.classList.add('is-loading');
    changing = changing.then(function () {
      return request('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: cartSectionIds(), sections_url: window.location.pathname })
      })
        .then(function (response) { return response.json().then(function (json) { return { ok: response.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.json.description || 'cart');
          renderCartSections(result.json.sections);
          var d = drawer();
          if (d && d.classList.contains('active') && !$('.cart-item', d)) d.close();
          document.dispatchEvent(new CustomEvent('kraba:cart-updated', { detail: result.json }));
        })
        .catch(function () {
          if (line) line.classList.remove('is-loading');
          $$('.cart-drawer__errors').forEach(function (e) { e.hidden = false; });
        });
    });
    return changing;
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('input[data-kraba-cart-key]');
    if (!input) return;
    changeLine(input.dataset.krabaCartKey, parseInt(input.value, 10) || 0, input);
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-kraba-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.dataset.krabaCartRemove, 0, remove);
      return;
    }
    /* the header's cart icon opens the drawer instead of leaving the page */
    var icon = event.target.closest('#cart-icon-bubble');
    if (icon && drawer() && window.location.pathname !== '/cart') {
      event.preventDefault();
      openDrawer();
    }
  });

  /* card "Dodaj u korpu" */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[data-kraba-card-form]')) return;
    if (event.defaultPrevented) return;
    event.preventDefault();
    addToCart(form, $('button[type="submit"]', form), false);
  });

  /* ======================================================================
     Quick add window: the product page itself, in a dialog
     ====================================================================== */
  if (!customElements.get('quick-add-modal')) {
    customElements.define('quick-add-modal', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (event) {
          if (event.target === self || event.target.closest('[data-kraba-modal-close]')) self.hide();
        });
      }
      show(html) {
        var body = $('.quick-add-modal__content-info', this);
        body.innerHTML = '';
        body.appendChild(html);
        this.classList.add('is-open');
        this.setAttribute('open', '');
        document.documentElement.classList.add('kraba-modal-open');
        $$('[data-kraba-product]', body).forEach(initProduct);
        document.dispatchEvent(new CustomEvent('kraba:quick-add-open', { detail: { modal: this } }));
      }
      hide() {
        this.classList.remove('is-open');
        this.removeAttribute('open');
        document.documentElement.classList.remove('kraba-modal-open');
      }
    });
  }

  function quickAddModal() {
    var modal = $('quick-add-modal');
    if (modal) return modal;
    modal = document.createElement('quick-add-modal');
    modal.className = 'quick-add-modal';
    modal.innerHTML =
      '<div class="quick-add-modal__content" role="dialog" aria-modal="true">' +
      '<button type="button" class="quick-add-modal__toggle" data-kraba-modal-close aria-label="Zatvori">' +
      '<svg viewBox="0 0 18 17" fill="none" aria-hidden="true"><path d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268-7.418 7.417Z" fill="currentColor"/></svg>' +
      '</button><div class="quick-add-modal__content-info"></div></div>';
    document.body.appendChild(modal);
    return modal;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-kraba-quick-add]');
    if (!opener) return;
    event.preventDefault();
    opener.classList.add('loading');
    request(opener.dataset.krabaQuickAdd)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var section = $('[data-kraba-product]', parse(html));
        if (!section) { window.location.href = opener.dataset.krabaQuickAdd; return; }
        /* the window shows the decision, not the long read under it */
        $$('.kraba-bundle, .product__accordion, sticky-atc, script[type="application/ld+json"]', section).forEach(function (n) { n.remove(); });
        quickAddModal().show(document.importNode(section, true));
      })
      .catch(function () { window.location.href = opener.dataset.krabaQuickAdd; })
      .then(function () { opener.classList.remove('loading'); });
  });

  /* ======================================================================
     Slide-out menu
     ====================================================================== */
  if (!customElements.get('kraba-menu-drawer')) {
    customElements.define('kraba-menu-drawer', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.main = $('#Details-menu-drawer-container', this);
        if (!this.main) return;
        var summary = $(':scope > summary', this.main);
        summary.addEventListener('click', function (event) {
          event.preventDefault();
          if (self.main.hasAttribute('open')) self.close(); else self.open();
        });
        $$('.menu-drawer__close-btn', this).forEach(function (b) {
          b.addEventListener('click', function (event) { event.preventDefault(); self.close(); });
        });
        $$('.menu-drawer__submenu', this).forEach(function (sub) {
          var details = sub.closest('details');
          var s = $(':scope > summary', details);
          s.addEventListener('click', function (event) {
            event.preventDefault();
            details.setAttribute('open', '');
            setTimeout(function () { details.classList.add('menu-opening'); }, 10);
          });
          var back = $('.menu-drawer__close-button', sub);
          if (back) back.addEventListener('click', function (event) {
            event.preventDefault();
            details.classList.remove('menu-opening');
            setTimeout(function () { details.removeAttribute('open'); }, 250);
          });
        });
        this.main.addEventListener('click', function (event) {
          if (event.target === self.main || event.target.classList.contains('menu-drawer-container')) self.close();
        });
        document.addEventListener('keyup', function (event) { if (event.key === 'Escape') self.close(); });
        document.addEventListener('click', function (event) {
          if (!self.main.hasAttribute('open')) return;
          if (!event.target.closest('#menu-drawer') && !event.target.closest('#Details-menu-drawer-container > summary')) self.close();
        });
      }
      open() {
        this.main.setAttribute('open', '');
        var main = this.main;
        setTimeout(function () { main.classList.add('menu-opening'); }, 10);
        document.body.classList.add('overflow-hidden-tablet');
        var summary = $(':scope > summary', main);
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
      close() {
        var main = this.main;
        if (!main || !main.hasAttribute('open')) return;
        main.classList.remove('menu-opening');
        $$('details', main).forEach(function (d) { d.classList.remove('menu-opening'); d.removeAttribute('open'); });
        document.body.classList.remove('overflow-hidden-tablet');
        var summary = $(':scope > summary', main);
        if (summary) summary.setAttribute('aria-expanded', 'false');
        setTimeout(function () { main.removeAttribute('open'); }, 250);
      }
    });
  }

  /* desktop category panel: one open at a time, closed by a click elsewhere */
  document.addEventListener('click', function (event) {
    $$('details.kraba-mega[open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    $$('details.kraba-mega[open]').forEach(function (d) { d.removeAttribute('open'); });
    var dr = drawer();
    if (dr && dr.classList.contains('active')) dr.close();
    var modal = $('quick-add-modal.is-open');
    if (modal) modal.hide();
  });

  /* ======================================================================
     Header search with suggestions
     ====================================================================== */
  if (!customElements.get('kraba-predictive-search')) {
    customElements.define('kraba-predictive-search', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.input = $('input[type="search"]', this);
        this.results = $('[data-predictive-search]', this);
        this.reset = $('button[type="reset"]', this);
        this.status = $('.predictive-search-status', this);
        if (!this.input || !this.results) return;
        this.timer = null;
        this.input.addEventListener('input', function () {
          clearTimeout(self.timer);
          var q = self.input.value.trim();
          if (self.reset) self.reset.classList.toggle('hidden', !q);
          if (!q) { self.close(); return; }
          self.timer = setTimeout(function () { self.search(q); }, 250);
        });
        this.input.addEventListener('focus', function () {
          if (self.input.value.trim() && self.results.innerHTML.trim()) self.openResults();
        });
        if (this.reset) this.reset.addEventListener('click', function () {
          setTimeout(function () { self.input.value = ''; self.close(); self.reset.classList.add('hidden'); self.input.focus(); }, 0);
        });
        document.addEventListener('click', function (event) { if (!self.contains(event.target)) self.close(); });
        this.addEventListener('keyup', function (event) { if (event.key === 'Escape') { self.close(); self.input.blur(); } });
      }
      search(q) {
        var self = this;
        this.setAttribute('loading', '');
        request('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=kraba-predictive-search')
          .then(function (response) { return response.text(); })
          .then(function (html) {
            if (self.input.value.trim() !== q) return;
            var box = $('#predictive-search-results', parse(html));
            self.results.innerHTML = box ? box.outerHTML : '';
            self.openResults();
          })
          .catch(function () { self.close(); })
          .then(function () { self.removeAttribute('loading'); });
      }
      openResults() {
        this.setAttribute('open', '');
        this.results.style.display = 'block';
        this.input.setAttribute('aria-expanded', 'true');
      }
      close() {
        this.removeAttribute('open');
        this.results.style.display = '';
        this.input.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ======================================================================
     Small things
     ====================================================================== */
  document.addEventListener('click', function (event) {
    var share = event.target.closest('[data-kraba-share]');
    if (!share) return;
    event.preventDefault();
    var url = share.dataset.url || window.location.href;
    if (navigator.share) {
      navigator.share({ title: share.dataset.title || document.title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { share.classList.add('is-copied'); setTimeout(function () { share.classList.remove('is-copied'); }, 1500); });
    }
  });

  /* rows that swipe sideways get dots */
  function initRow(track) {
    if (track.dataset.ready) return;
    track.dataset.ready = '1';
    var dotsHost = track.parentElement.querySelector('[data-kraba-row-dots]');
    if (!dotsHost) return;
    function build() {
      var pages = Math.max(1, Math.ceil(track.scrollWidth / Math.max(1, track.clientWidth) - 0.05));
      dotsHost.innerHTML = '';
      if (pages < 2) return;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'kraba-featured__dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', (i + 1) + ' / ' + pages);
        (function (n) { b.addEventListener('click', function () { track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); }); })(i);
        dotsHost.appendChild(b);
      }
    }
    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      $$('.kraba-featured__dot', dotsHost).forEach(function (d, i) { d.classList.toggle('is-active', i === n); });
    }, { passive: true });
    build();
    window.addEventListener('resize', build);
  }

  function start() {
    $$('[data-kraba-product]').forEach(initProduct);
    $$('[data-kraba-row]').forEach(initRow);
    var d = drawer();
    if (d && d.syncEmpty) d.syncEmpty();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
